import {
    useEffect,
    useState,
} from 'react';

import {Autocomplete,} from '@mantine/core';
import {FieldProps} from 'formik';
import {TopLevelDomain} from "../../top-level-domains/types.ts";
import {useRegistrars} from "../hooks/useRegistrars.ts";


export const RegistrarsAutocomplete = ({
                                           field: {
                                               name,
                                               value: fieldValue,
                                           },
                                           form: {setFieldValue},
                                           ...rest
                                       }: FieldProps) => {

    const LABEL_PROPERTY = 'name'
    const VALUE_PROPERTY = 'id'

    const [value, setValue] = useState('');
    const [disabled, setDisabled] = useState(false);

    const {
        items: records,
        fetchRecords
    } = useRegistrars();

    useEffect(() => {
        fetchRecords();
        // FNP-960: deliberately mount-only. The callback is recreated on
        // every render, so adding it to the deps would re-fire in a loop.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        if (records.length === 0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    // FNP-960: was [records.length] while the effect READS fieldValue — a real
        // staleness bug, not a lint nit: selecting a different record without
        // changing the list length never re-ran it, so the displayed value went
        // stale. `records` is React Query data with a stable reference between
        // refetches, so this does not loop. Same defect as marketplace (FNP-958).
    }, [records, fieldValue]);

    useEffect(() => {
        const found = records.find((record: TopLevelDomain) => record[VALUE_PROPERTY] === fieldValue);
        if (typeof found !== 'undefined') {
            setValue(found[LABEL_PROPERTY] ?? '');
        }
    }, [records, fieldValue]);

    const handleChange = (value: string) => {
        const found = records.find((record: TopLevelDomain) => record[LABEL_PROPERTY] === value);
        if (typeof found !== 'undefined') {
            setFieldValue(name, found[VALUE_PROPERTY]);
        }
        setValue(value);
    };

    const data = records.map((record: TopLevelDomain) => {
        return {
            label: record[LABEL_PROPERTY],
            value: record[VALUE_PROPERTY],
        };
    });


    return (
        <Autocomplete
            name={name}
            value={value}
            onChange={handleChange}
            data={data}
            disabled={disabled}
            placeholder='Select Component'
            {...rest}
        />
    );
};
